var _rect, _rect2, _rect3, _g, _circle, _g2, _g3, _g4, _line, _line2, _line3, _line4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddKafkaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4530",
    "data-name": "Group 4530",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 22,
    height: 22,
    transform: "translate(1 1)",
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1152",
    "data-name": "Rectangle 1152",
    width: 24,
    height: 24,
    fill: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1334",
    "data-name": "Rectangle 1334",
    width: 22,
    height: 22,
    transform: "translate(1 1)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_198",
    transform: "translate(6 1.05)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198-2",
    "data-name": "Ellipse 198",
    cx: 2.25,
    cy: 2.25,
    r: 2.25,
    transform: "translate(0.75 0.75)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(5 8.05)",
    fill: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_199-2",
    "data-name": "Ellipse_199",
    transform: "translate(13 5.05)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 2.25,
    cy: 2.25,
    r: 2.25,
    transform: "translate(0.75 0.75)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_201-2",
    "data-name": "Ellipse_201",
    transform: "translate(13 13.05)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 2.25,
    cy: 2.25,
    r: 2.25,
    transform: "translate(0.75 0.75)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_200-2",
    "data-name": "Ellipse_200",
    transform: "translate(6 17.05)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 2.25,
    cy: 2.25,
    r: 2.25,
    transform: "translate(0.75 0.75)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    y2: 2.5,
    transform: "translate(9 6.3)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    y2: 2.5,
    transform: "translate(9 15.3)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    x1: 2.07,
    y2: 1.4,
    transform: "translate(11.77 9.03)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    x2: 2.07,
    y2: 1.4,
    transform: "translate(11.77 13.56)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add-circle",
    d: "M11.44,3.63a3.8,3.8,0,1,0,2.7,1.114,3.81,3.81,0,0,0-2.7-1.114ZM12.9,7.736H11.736V8.9a.3.3,0,1,1-.593,0V7.736H9.975a.3.3,0,1,1,0-.593h1.168V5.975a.3.3,0,0,1,.593,0V7.144H12.9a.3.3,0,1,1,0,.593Z",
    transform: "translate(-2.25 4.56)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddKafkaIcon);
export default __webpack_public_path__ + "static/media/add-kafka-icon.93b132bc2a3061bf7ccd0fd7c2bca4d5.svg";
export { ForwardRef as ReactComponent };